import React, {HTMLAttributes} from 'react';
import './index.scss';

export interface Props extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  required?: boolean;
}

const Label: React.FC<Props> = ({children = 'example', ...props}: Props) => {
  const classnames = `label${props.required ? ' required' : ''}`;
  return (
    <label htmlFor={props.id} className={classnames}>
      {children}
    </label>
  );
};

Label.defaultProps = {
  required: false
};

export default Label;
